import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';
import { navEnabledIfCountGreaterThanZero, ButtonWidget } from '@overview/models/button-widget';
import * as userActions from '@users/actions/users';
import * as userSelectors from '@users/selectors/users';
import * as userReducers from '@users/reducers/users';

const TILE_CLASS_TOTAL_USERS = 'admin-overview-tile-total-users';
const TILE_CLASS_NEW_USERS = 'admin-overview-tile-new-users';
const TILE_CLASS_UNCONFIRMED_USERS = 'admin-overview-tile-unconfirmed-users';
const TILE_CLASS_LIVE_USERS = 'admin-overview-tile-live-users';

@Injectable({
  providedIn: 'root',
})
export class AdminOverviewTileService {

  constructor(
    private readonly store: Store<userReducers.State>
  ) {

    this.store.select(userSelectors.selectMciUserState).pipe(map(u => {
      console.log(u);
    }));

    this.store.select(userSelectors.selectUserCounts).pipe(
      map(counts => {
        const items: Array<ButtonWidget> = [];
        const add = (label: string, count: number, filter: string, className: string) => items.push(new ButtonWidget(label, true, count, '', '/users', false, className, navEnabledIfCountGreaterThanZero, { filter: filter }));
        add('Total Users', counts['All'], 'All', TILE_CLASS_TOTAL_USERS);
        add('New Users', counts['New'], 'New', TILE_CLASS_NEW_USERS);
        add('Unconfirmed Users', counts['Unconfirmed'], 'Unconfirmed', TILE_CLASS_UNCONFIRMED_USERS);
        add('Live Users', counts['Live'], 'Live', TILE_CLASS_LIVE_USERS);
        this._tiles.next(items);
      })).subscribe();
  }

  private _tiles = new BehaviorSubject<Array<ButtonWidget>>([]);

  get tiles() {
    return this._tiles.asObservable();
  }

  loadTiles() {
    this.store.dispatch(new userActions.Load());
  }


}

